module.exports = __webpack_public_path__ + "img/42.4a9793f5.jpg";